/* eslint-disable */
/* Code generated by generate-angular-formgroups.mjs DO NOT EDIT. */
import { signal, WritableSignal } from '@angular/core';
import { form, email, maxLength, min, minLength, required, SchemaPathTree } from '@angular/forms/signals';
import { LexplusCreateAdminBenutzerDto } from '../models';

/** Initial value for the signal model. */
export function getLexplusCreateAdminBenutzerDtoInitialValue(): LexplusCreateAdminBenutzerDto {
  return {
  vorname: '',
  nachname: '',
  email: '',
  spracheID: null,
  aktiv: false,
  twoFactorEnabled: false,
  gueltigAb: null,
  gueltigBis: null,
  kundeID: 0,
  istNeosysAdmin: false,
  istKundeAdmin: false,
} as LexplusCreateAdminBenutzerDto;
}

/**
 * Reusable Signal Forms schema for LexplusCreateAdminBenutzerDto.
 * Can be passed to form() directly or embedded via apply()/applyEach().
 */
export function lexplusCreateAdminBenutzerDtoSchema(path: SchemaPathTree<LexplusCreateAdminBenutzerDto>): void {
  required(path.vorname);
  minLength(path.vorname, 1);
  maxLength(path.vorname, 128);
  required(path.nachname);
  minLength(path.nachname, 1);
  maxLength(path.nachname, 128);
  required(path.email);
  email(path.email);
  maxLength(path.email, 256);
  required(path.kundeID);
  min(path.kundeID, 1);
}

/**
 * Creates the model signal and the form in one call.
 * The model signal is needed for submit(), for example: submit(field, { action }).
 */
export function createLexplusCreateAdminBenutzerDtoForm(initial?: Partial<LexplusCreateAdminBenutzerDto>) {
  const model: WritableSignal<LexplusCreateAdminBenutzerDto> = signal<LexplusCreateAdminBenutzerDto>({
    ...getLexplusCreateAdminBenutzerDtoInitialValue(),
    ...initial,
  } as LexplusCreateAdminBenutzerDto);
  return { model, field: form(model, lexplusCreateAdminBenutzerDtoSchema) };
}
